module.exports = __webpack_public_path__ + "img/design.d22116f4.png";